/**
 * InfoBox.jsx
 * Caja informativa dentro de formularios.
 * variant: 'info' (verde, default) | 'warning' (ámbar)
 */
import f from '../../styles/forms.module.css';

const ICONS = {
  info:    'ℹ',
  warning: '⚠',
};

const InfoBox = ({ children, variant = 'info' }) => (
  <div className={`${f.infoBox} ${variant === 'warning' ? f.infoBoxWarning : ''}`} role="note">
    <em className={f.infoBoxIcon} aria-hidden="true">{ICONS[variant]}</em>
    <span>{children}</span>
  </div>
);

export default InfoBox;
